import { Container, Row, Col } from "reactstrap";
import footerItems from "../../../../assets/images/footer-items.png";
import twitterIcon from "../../../../assets/images/Group 31.svg";
import facebookIcon from "../../../../assets/images/Group 34.svg";
import instagramIcon from "../../../../assets/images/Group 43.svg";
import linkedInIcon from "../../../../assets/images/Group 39.svg";

import "./index.scss";

const FooterSection = () => {
  return (
    <section className="footer-section">
      <Container>
        <Row>
          <Col sm="5" md="5" lg="5" className="social-content">
            <div className="social-media">
              <a href="https://www.facebook.com/3IKCareerPlus ">
                <img src={facebookIcon} alt="facebook" />
              </a>
              <a href="https://twitter.com/3IKCareerPlus ">
                <img src={twitterIcon} alt="twitter" />
              </a>
              <a href="https://instagram.com/3ikcareerplus?igshid=Nzg3NjI1NGI=">
                <img src={instagramIcon} alt="instagram" />
              </a>
              <a href="https://www.linkedin.com/company/careerplus/">
                <img src={linkedInIcon} alt="linkedIn" />
              </a>
            </div>
            <a className="info-mail" href="mailto:info@careerplus.org">
              info@careerplus.org
            </a>
          </Col>
          <Col
            sm="7"
            md="7"
            lg="7"
            className="d-flex justify-content-end align-items-center footer-right"
          >
            <img src={footerItems} alt="footer-items" />
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default FooterSection;
